import { CATEGORIES, SUGGESTED_EQUIPMENTS } from "../../../constants/equipments"; // 🆕 ajuste le chemin

// 🆕 regroupe les suggestions par catégorie pour l'affichage en grille
const itemsByCategory = (catId) =>
  SUGGESTED_EQUIPMENTS.filter(e => e.category === catId).map(e => e.name);

export default function EquipmentsStep({ formData, setFormData }) {

  const isSelected = (name) =>
    formData.equipments.some(e => e.name === name);

  // 🆕 stocke {name, category: id} — même format/ids que EquipmentsManager
  const toggle = (item, categoryId) => {
    setFormData(prev => ({
      ...prev,
      equipments: isSelected(item)
        ? prev.equipments.filter(e => e.name !== item)
        : [...prev.equipments, { name: item, category: categoryId }]
    }));
  };

  return (
    <div className="space-y-8">
      <div>
        <h2 className="text-2xl font-semibold">
          Équipements
        </h2>
        <p className="text-gray-500 mt-1">
          Sélectionnez les équipements disponibles dans votre établissement
        </p>
      </div>

      <div className="space-y-6">
        {CATEGORIES.filter(cat => cat.id !== "autre").map(cat => { // 🆕 boucle sur CATEGORIES partagé
          const items = itemsByCategory(cat.id);
          if (items.length === 0) return null;

          return (
            <div key={cat.id}>
              <h3 className="font-semibold mb-3 text-lg flex items-center gap-2">
                <cat.Icon size={18} strokeWidth={2} /> {/* 🆕 icône cohérente avec le back-office */}
                {cat.label}
              </h3>

              <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
                {items.map(item => {
                  const isActive = isSelected(item);
                  return (
                    <div
                      key={item}
                      onClick={() => toggle(item, cat.id)} // 🆕 passe l'id, pas le label
                      className={`cursor-pointer px-4 py-3 rounded-xl border transition text-sm
                        ${
                          isActive
                            ? "bg-green-50 border-green-500 text-green-700"
                            : "bg-white border-gray-200 hover:border-gray-400"
                        }
                      `}
                    >
                      {item}
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>

      {formData.equipments.length > 0 && (
        <div className="text-sm text-gray-500">
          {formData.equipments.length} équipement(s) sélectionné(s)
        </div>
      )}
    </div>
  );
}